export default function NewWindowIcon({ size = '24px' }) {
  return(
    <svg xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fillRule="evenodd"d="M25.75 13h-1.5a.25.25 0 00-.25.25V24H8V8h10.75a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H6.25a.25.25 0 00-.25.25v19.5c0 .138.112.25.25.25h19.5a.25.25 0 00.25-.25v-12.5a.25.25 0 00-.25-.25m2-9h-6.5a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h3.336l-8 8a.25.25 0 000 .354l1.06 1.06a.25.25 0 00.354 0l8-8v3.336c0 .138.112.25.25.25h1.5a.25.25 0 00.25-.25v-6.5a.25.25 0 00-.25-.25"
      />
    </svg>
  )
}